<template>
  <van-popup
    :value="show"
    @close="close"
    @click-close-icon="close"
    position="bottom"
    class="popup"
  >
    <div class="wrap">
      <van-icon name="cross" color="#CCCCCC" class="icon" @click="close" />
      <div class="sub-title">建议保留权益</div>
      <div class="title">加赠<span>权益价值1288元</span>精选福利</div>
      <div class="benefit-list">
        <div class="benefit-item"></div>
      </div>
      <div class="desc">
        <img
          class="img"
          src="https://common-h5-dev.xiangshuheika.com/static/upload/202605143968bdd816598.png"
        />
        保障收入不中断·<span>免费领238元失能险</span>
      </div>
      <div class="btn" @click="close">去使用</div>
      <div class="cancel-btn" @click="close">放弃权益 仍要退费</div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close", false);
    };

    return {
      close,
    };
  },
});
</script>

<style lang="less" scoped>
.popup {
  border-radius: 8px 8px 0px 0px;
}

.wrap {
  min-height: 387px;
  background: linear-gradient(180deg, #e1effc 0%, #ffffff 100%), #ffffff;
  position: relative;
  padding: 28px 12px 39px 12px;
  box-sizing: border-box;

  .icon {
    font-size: 16px;
    font-weight: 600;
    position: absolute;
    right: 16px;
    top: 20px;
  }

  .sub-title {
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    line-height: 20px;
    padding-left: 9px;
  }

  .title {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    margin-top: 4px;
    padding-left: 9px;

    > span {
      color: #e4681d;
    }
  }

  .benefit-list {
    margin-top: 24px;

    .benefit-item {
      overflow: hidden;
      background: #fff7f2;
      margin: 0 4px;
      width: auto;
      height: 108px;
      border-radius: 8px;
      background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2026051416f5824284ddf.png")
        no-repeat;
      background-size: contain;
    }
  }

  .desc {
    display: flex;
    align-items: center;
    padding-left: 16px;

    margin-top: 26px;

    font-weight: 500;
    font-size: 12px;
    color: #333333;
    line-height: 17px;

    > span {
      color: #e4681d;
    }

    > img {
      margin-right: 7px;
      width: 13px;
      height: 10px;
    }
  }

  .btn {
    height: 44px;
    background: linear-gradient(90deg, #4082e7 0%, #3254f2 100%);
    border-radius: 26px;
    font-weight: 600;
    font-size: 17px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    margin-top: 24px;
  }

  .cancel-btn {
    margin-top: 16px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }
}
</style>
